import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mobile",
  "use": "icon-mobile-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-mobile\">\r\n<style type=\"text/css\">\r\n\t#icon-mobile .st0{fill:#FFFFFF;}\r\n</style>\r\n<g>\r\n\t<g>\r\n\t\t<path class=\"st0\" d=\"M15.2,2.3H8.4C7,2.3,5.8,3.4,5.8,4.9v13.7c0,1.4,1.1,2.6,2.6,2.6h6.8c1.4,0,2.6-1.1,2.6-2.6V4.9\r\n\t\t\tC17.8,3.4,16.6,2.3,15.2,2.3L15.2,2.3z M13.5,19.4h-3.4v-0.9h3.4V19.4z M16.3,16.8h-9v-12h9V16.8z M16.3,16.8\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mobile.svg
// module id = ofrD
// module chunks = 22